import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Payload = {
  routeIds: string[]
  autoDownloadFile?: boolean
  config: {
    format: 'XLSX' | 'CSV' | 'HTML' | 'EMAIL' | 'PDF'
    includePod?: boolean
    includeBarcodes?: boolean
    timeFormat?: string
    currentRoutes?: boolean
    exportedLoads?: string[]
    exportedCustomFields?: string[]
    requestedColumns?: {
      columnId: string
      label: string
    }[]
  }
}

/**
 * Export routes in different formats
 *
 * @private
 */
export const exportRoutes = createAsyncThunk<
  // Return type of the payload creator
  string | uui.domain.actions.rpc.route.EmailExportResult | null,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/route/export', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/route/export', {
      category: 'rpc',
      type: 'rpc/route/export',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    // Download the attachment
    if (payload.autoDownloadFile && typeof response.result === 'string') {
      window.open(response.result)
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {exportRoutes}`,
      { tags: ['rpc', 'order'], info: { payload, error } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Export routes [${payload.routeIds.join(', ')}] failed`,
      error,
    })
  }
})
